import React, { useState } from "react";
import Loading from "../_partials/loading/loading";

type RegisterFormProps = {
	mobile: string;
	setMobile: (val: string) => void;
	username: string;
	setUsername: (val: string) => void;
	password: string;
	setPassword: (val: string) => void;
	refCode: string;
	setRefCode: (val: string) => void;
	onSwitchMode: (mode: "login" | "register" | "otp") => void;
};

export function RegisterForm({
	mobile,
	setMobile,
	username,
	setUsername,
	password,
	setPassword,
	refCode,
	setRefCode,
	onSwitchMode,
}: RegisterFormProps) {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const handleRegister = async () => {
		setLoading(true);
		setError(null);

		try {
			const res = await fetch("/api/pre-register", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					mobile: mobile,
					username,
					password,
					referralCode: refCode,
				}),
			});

			if (res.ok) {
				onSwitchMode("otp");
			} else {
				const data = await res.json().catch(() => null);
				if (data?.message?.includes("UserAlreadyExistException")) {
					setError("کاربر با این شماره یا نام کاربری از قبل وجود دارد");
				} else if (data?.message?.includes("AlreadyValidOtpException")) {
					setError("یک کد معتبر قبلاً ارسال شده است. لطفاً کمی صبر کنید.");
				} else if (data?.message?.includes("SendSmsException")) {
					setError("خطا در ارسال پیامک. لطفاً دوباره تلاش کنید.");
				} else {
					setError("خطای ناشناخته. لطفاً دوباره تلاش کنید.");
				}
			}
		} catch (err) {
			setError("خطا در ارتباط با سرور");
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="w-full flex flex-col gap-2 text-[18px]">
			<label htmlFor="username">نام کاربری</label>
			<input
				dir="ltr"
				id="username"
				type="text"
				placeholder="username"
				className="w-full p-3 mb-4 bg-gray-600 border border-gray-400 rounded-lg focus:outline-none focus:ring-2 focus:ring-custom-pink text-left"
				value={username}
				onChange={(e) => setUsername(e.target.value)}
			/>

			<label htmlFor="call">شماره تماس</label>
			<input
				dir="ltr"
				id="call"
				type="text"
				placeholder="09..."
				className="w-full p-3 mb-4 bg-gray-600 border border-gray-400 rounded-lg focus:outline-none focus:ring-2 focus:ring-custom-pink text-left"
				value={mobile}
				onChange={(e) => setMobile(e.target.value)}
			/>

			<label htmlFor="password">رمز عبور</label>
			<input
				dir="ltr"
				id="password"
				type="password"
				placeholder="Password"
				className="w-full p-3 mb-4 bg-gray-600 border border-gray-400 rounded-lg focus:outline-none focus:ring-2 focus:ring-custom-pink text-left"
				value={password}
				onChange={(e) => setPassword(e.target.value)}
			/>

			<label htmlFor="refCode">کد دعوت</label>
			<input
				dir="rtl"
				id="refCode"
				type="text"
				placeholder="کد دعوت"
				className="w-full p-3 mb-4 bg-gray-600 border border-gray-400 rounded-lg focus:outline-none focus:ring-2 focus:ring-custom-pink text-left"
				value={refCode}
				onChange={(e) => setRefCode(e.target.value)}
			/>

			<div className="flex w-full justify-between text-[15px] text-white mb-4">
				<button
					className="opacity-70 hover:opacity-100"
					onClick={() => onSwitchMode("login")}
				>
					قبلاً ثبت نام کرده‌ام
				</button>
			</div>

			<button
				type="submit"
				onClick={handleRegister}
				disabled={loading}
				className="text-black text-[20px] font-normal relative hover:opacity-70 m-auto disabled:opacity-50"
				style={{
					backgroundImage: "url(/authentication-button.png)",
					backgroundPosition: "center",
					backgroundRepeat: "no-repeat",
					width: "180px",
					height: "50px",
				}}
			>
				{loading ? "در حال ثبت‌نام..." : "ثبت‌نام"}
			</button>

			{error && <p className="text-red-400 text-center mt-2">{error}</p>}
		</div>
	);
}
